/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Smart Home API
 * A smart home management system providing REST APIs for device integrations and automation
 * OpenAPI spec version: 1.0
 */

export type MqttCreateDeviceRequestDeviceType =
  (typeof MqttCreateDeviceRequestDeviceType)[keyof typeof MqttCreateDeviceRequestDeviceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MqttCreateDeviceRequestDeviceType = {
  switch: 'switch',
  light: 'light',
  window_covering: 'window_covering',
  fan: 'fan',
  speaker: 'speaker',
  tv: 'tv',
} as const;
